module.exports = __webpack_public_path__ + "img/avatar6.5a624060.png";